import { useState, useEffect } from 'react';
import { json } from 'react-router-dom';
import Axios from '../utils/axiosInstance';

const useFaqs = () => {
  const [Faqs, setFaqs] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await Axios.get(`${process.env.REACT_APP_API_BASE_URL}policies/faqs/`);
        setFaqs(response.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchFaqs();
  }, []);

  return { Faqs};
};

export default useFaqs;
